/**
 * URL for AI filter session progress (people or companies).
 *
 * In the browser we always hit the Next.js proxy — `components/tabs/leads-v2/api.ts`
 * defaulted to `http://0.0.0.0:8087`, which triggers CORS when the leads server
 * does not send Access-Control-Allow-Origin.
 *
 * Server-side callers (rare) use the configured leads base URL directly.
 */
export function buildAiFilterProgressUrl(
    sessionId: string,
    mode: "people" | "companies",
    page: number,
    pageSize: number,
): string {
    const params = new URLSearchParams({
        session_id: sessionId,
        page: String(page),
        page_size: String(pageSize),
        mode: mode === "companies" ? "companies" : "people",
    })

    if (typeof window !== "undefined") {
        return `/api/leads-v2/ai-filter-progress?${params.toString()}`
    }

    const base =
        process.env.NEXT_PUBLIC_ASYNC_LEAD_API_URL_2 ||
        process.env.NEXT_PUBLIC_LEADS_V2_API_URL ||
        "http://127.0.0.1:8087"
    const path =
        mode === "companies"
            ? "/ai-filter/company/progress"
            : "/ai-filter/progress"
    const u = new URL(`${base.replace(/\/$/, "")}${path}`)
    u.searchParams.set("session_id", sessionId)
    u.searchParams.set("page", String(page))
    u.searchParams.set("page_size", String(pageSize))
    return u.toString()
}
